import axios, { AxiosInstance } from "axios";
import { EnvironmentService } from "@/services/EnvironmentService";

export class BaseService {
  instance: AxiosInstance;

  constructor(name: string, timeout: number, contentType = "application/json") {
    const baseURL = EnvironmentService.getVariable(name);
    this.instance = axios.create({
      baseURL,
      timeout,
      headers: {
        Accept: contentType,
        "Content-Type": contentType,
      },
    });
  }
  getInstance(): AxiosInstance {
    return this.instance;
  }
}
